/** MUI BottomNavigation content row height (before safe-area padding). */
export const MOBILE_BOTTOM_NAV_HEIGHT_PX = 56;

/** Bottom padding for main scroll area: bottom nav + home indicator safe area. */
export const MOBILE_MAIN_BOTTOM_PADDING = `calc(${MOBILE_BOTTOM_NAV_HEIGHT_PX}px + env(safe-area-inset-bottom, 0px))`;

export const SAFE_AREA_TOP = 'env(safe-area-inset-top, 0px)';
export const SAFE_AREA_BOTTOM = 'env(safe-area-inset-bottom, 0px)';
export const SAFE_AREA_LEFT = 'env(safe-area-inset-left, 0px)';
export const SAFE_AREA_RIGHT = 'env(safe-area-inset-right, 0px)';

/** MUI default Toolbar min-height + top safe area (desktop shell). */
export const MAIN_TOP_OFFSET = `calc(64px + ${SAFE_AREA_TOP})`;

/**
 * Dense Toolbar (48px) + top safe area — matches `Toolbar variant="dense"` on mobile shell
 * so main `margin-top` is not oversized vs the fixed AppBar.
 */
export const MAIN_TOP_OFFSET_MOBILE_SHELL = `calc(48px + ${SAFE_AREA_TOP})`;

/** Minimum main column height on mobile (dense bar + top inset). */
export const MOBILE_MAIN_MIN_HEIGHT = `calc(100vh - 48px - env(safe-area-inset-top, 0px))`;
